<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<el-button @click="addUser" type="primary">
					{{ $t('device.add') }}
				</el-button>
			</template>
			<el-table :data="appData" :default-sort="{prop: 'date', order: 'descending'}" border stripe
				style="width: 100%">
				<el-table-column label="ID" prop="id" width="60"></el-table-column>
				<el-table-column label="名称" prop="name" width="200"></el-table-column>
				<el-table-column label="key" prop="key" width="350"></el-table-column>
				<el-table-column label="地图平台" prop="map_platform" width="120">
					<template #default="scope">{{ getMapPlatformName(scope.row.map_platform)  }}</template>
				</el-table-column>
				<el-table-column label="状态" prop="status" width="120">
					<template #default="scope">{{ getTypeName(scope.row.status)  }}</template>
				</el-table-column>
				<el-table-column label="时间" prop="create_at" width="180"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="150">
					<template #default="scope">
						<el-button @click="handleEdit(scope.row)" type="primary" size="small">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20, 50, 200]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" fixed="right"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>

			<el-dialog center title="添加/编辑" top="30vh" v-model="addPop" width="50%">
				<el-form :model="addForm" ref="addForm" :rules="rules">
					<el-form-item label="名称" label-width="120px" prop="name">
						<el-input type="text" v-model="addForm.name" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="key" label-width="120px" prop="name">
						<el-input type="text" v-model="addForm.key" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="地图平台" label-width="120px" prop="map_platform">
						<el-select v-model="addForm.map_platform" placeholder="请选择地图平台" style="width:100%">
							<el-option v-for="item in mapPlatformOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="使用状态" label-width="120px" prop="type">
						<el-select v-model="addForm.status" placeholder="请选择状态" style="width:100%">
							<el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="addPop = false">{{ $t('device.cancel') }}</el-button>
						<el-button @click="handleSubmit" type="primary">{{ $t('device.confirm') }}</el-button>
					</span>
				</template>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
	import message from "../../model/mapKey";

	export default {
		name: "user",
		data() {
			return {
				dialogFormVisible: false,
				formInline: {
					name: "",
					page: 1,
					size: 50
				},
				resetform: {
					name: "",
				},
				listCount: 0,
				appData: [],
				addPop: false,
				addForm: {
					name: "",
					key: "",
					status: 0,
					map_platform: 1,
				},
				roleOpts: [],
				typeOptions: [
					{
						value: 0,
						label: "待使用"
					},{
						value: 1,
						label: "使用中"
					},
					{
						value: 2,
						label: "停止"
					}
				],
				mapPlatformOptions: [
					{
						value: 1,
						label: "高德"
					},{
						value: 2,
						label: "腾讯"
					}
				],
				rules: {
					name: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					key: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					status: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					map_platform: [{
						required: true,
						message: '请选择地图平台',
						trigger: "change"
					}]
				}
			};
		},
		async mounted() {
			await this.loadData();
		},
		methods: {
			truncateText(text, limit) {
				return text?.length > limit ? `${text.substr(0,  limit)}...` : text || '-';
			},
			getTypeName(type) {
				const target = this.typeOptions.find(item => item.value === type);
				return target?.label || '未知';
			},
			getMapPlatformName(type) {
				const target = this.mapPlatformOptions.find(item => item.value === type);
				return target?.label || '未知';
			},
			resetFun() {
				this.formInline.name = ''
				this.loadData()
			},
			async loadData() {
				const ret = await message.list(this.formInline)
				if (ret.code === 200) {
					this.appData = ret.data.list;
					this.listCount = ret.data.count;
				}
			},
			async handleSubmit() {
				this.$refs.addForm.validate(async valid => {
					if (valid) {
						const params = JSON.parse(JSON.stringify(this.addForm))
						const ret = await message.save(params)
						if (ret.code === 200) {
							this.addPop = false
							this.$message.success(ret.message)
							this.loadData()
						} else {
							this.$message.warning(ret.message)
						}
					} else {
						return false;
					}
				});
			},
			seachFun() {
				this.loadData();
			},
			addUser() {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					this.addForm = {
						name: "",
						key: "",
						map_platform: 1,
					}
				})
			},
			handleEdit(row) {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					let rowData = JSON.parse(JSON.stringify(row))
					this.addForm.name = rowData.name
					this.addForm.key = rowData.key
					this.addForm.id = rowData.id
					this.addForm.status = rowData.status
					this.addForm.map_platform = rowData.map_platform || 1
				})
			},
			async handleDelete(row) {
				this.$confirm(this.$t('device.delete_note'), this.$t('device.tip'), {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await message.delete({
							id: row.id
						});
						if (ret.code === 200) {
							this.$message.success('操作成功');
							await this.loadData()
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(error => {
						console.error(' 操作失败:', error);
						this.$message.error(' 操作失败，请稍后再试');
					});
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.loadData();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.loadData();
			}
		}
	};
</script>
<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.card-header {
		display: flex;
		align-items: center;
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}

	.tag-item {
		background-color: #f0f0f0;
		padding: 5px 10px;
		margin-right: 10px;
		border-radius: 4px;
		display: inline-flex;
		align-items: center;
	}

	.tag-item .el-icon-close {
		margin-left: 8px;
		cursor: pointer;
		color: red;
	}

	.tag-item .el-icon-close:hover {
		color: #666;
	}
</style>